module.exports = __webpack_public_path__ + "fonts/WorkSans-Bold.dc1f0f5.eot";